module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6ftO6i/tc-custom/9798337200064.jpg?1734012362394",
      "alt": "This image is the cover for the book Sisters"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Sisters\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From the author of "), _c('i', [_vm._v("Girl Out of Sight")]), _vm._v(", this gripping, tense novel tells the story of a drowned child, estranged sisters, and a home steeped in sorrow . . .")]), _c('br'), _c('br'), _vm._v(" Rachel thought she could outrun her past. But when her sister Imogen returns home after years abroad, the walls Rachel has built around herself begin to crumble."), _c('br'), _c('br'), _vm._v(" Two decades after the tragic loss of their baby brother, Rachel has constructed a life that appears perfect on the surface. A successful career, a loving daughter, and a claim on her parents’ beautiful family home, the Old Rectory."), _c('br'), _c('br'), _vm._v(" Imogen’s arrival rips open old wounds and exposes the cracks in Rachel’s façade. Once a carefree nomad, Imogen is now destitute and desperate, determined to reclaim her place in the family. Imogen wants what she believes is hers—no matter the cost."), _c('br'), _c('br'), _vm._v(" Now, as secrets resurface, danger looms, and bonds are tested, the only thing more dangerous than the past is the silence that has kept it hidden . . ."), _c('br'), _c('br'), _c('i', [_vm._v("The Sisters ")]), _vm._v("is a gripping tale of mourning, guilt, and the deadly consequences of unspoken truths."), _c('br'), _c('br'), _c('i', [_vm._v("Previously published under the title ")]), _vm._v("Façade.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helen Matthews\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0